const LARGE_BMI_THRESHOLD = 27.5;

export const bmiForHeightAndWeight = (height: number | undefined, weight: number | undefined) => {
  if (!weight || !height) {
    return 0;
  }
  // weight (kg) / [height (m)]2
  return weight / 1000 / (height / 100) ** 2;
};

export const isLargeBMI = (height: number | undefined, weight: number | undefined) => {
  const bmi = bmiForHeightAndWeight(height, weight);
  return bmi >= LARGE_BMI_THRESHOLD;
};
